<template>
  <a-flex vertical gap="middle">
    <RegistryMarkingCodesHeader></RegistryMarkingCodesHeader>

    <a-table
      :columns="tableColumns"
      :data-source="tableData"
      :loading="isDataLoading"
      :pagination="false"
      :scroll="{ x: 'max-content' }"
      :sticky="{ offsetHeader: 65 }"
      :row-key="(item: MarkingCodesRegistryTableItem) => item.id"
      @resizeColumn="handleResizeColumn"
      :row-selection="
        isDataLoading
          ? {}
          : {
              selectedRowKeys: selectedRowKeys,
              onChange: onRowSelectionChange,
            }
      "
    >
      <template #headerCell="{ column }">
        <RegistryMarkingCodesTableHeader :column="column" />
      </template>

      <template #bodyCell="{ column, record }">
        <RegistryMarkingCodesTableCell :column="column" :record="record" />
      </template>
    </a-table>

    <a-pagination
      style="margin-top: 20px; display: flex; justify-content: end"
      v-model:current="markingCodesRegistryStore.pagination.current"
      v-model:pageSize="markingCodesRegistryStore.pagination.pageSize"
      :showQuickJumper="markingCodesRegistryStore.pagination.showQuickJumper"
      :showSizeChanger="markingCodesRegistryStore.pagination.showSizeChanger"
      :showTotal="markingCodesRegistryStore.pagination.showTotal"
      :total="markingCodesRegistryStore.pagination.total"
      @change="markingCodesRegistryStore.pagination.onChangePagination"
    >
      <template #buildOptionText="props">
        <span>{{ props.value }} / странице</span>
      </template>
    </a-pagination>
  </a-flex>
</template>

<script setup lang="ts">
import RegistryMarkingCodesHeader from "@/components/product/marking/registryMarkingCodes/RegistryMarkingCodesHeader.vue";
import { handleResizeColumn } from "@/common/table/handleResizeColumn";
import RegistryMarkingCodesTableCell from "@/components/product/marking/registryMarkingCodes/RegistryMarkingCodesTableCell.vue";
import RegistryMarkingCodesTableHeader from "@/components/product/marking/registryMarkingCodes/RegistryMarkingCodesTableHeader.vue";
import {
  type MarkingCodesRegistryTableItem,
  useMarkingCodesRegistry,
} from "@/stores/product/marking/marking-codes-registry.store";
import { computed, onMounted } from "vue";

const markingCodesRegistryStore = useMarkingCodesRegistry();

const tableData = computed(() => markingCodesRegistryStore.tableData || []);
const tableColumns = computed(
  () => markingCodesRegistryStore.columnsFiltered || [],
);
const isDataLoading = computed(() => markingCodesRegistryStore.isDataLoading);
const selectedRowKeys = computed(
  () => markingCodesRegistryStore.selectedRowKeys,
);

const onRowSelectionChange = (
  selectedRowKeys: MarkingCodesRegistryTableItem["id"][],
) => {
  markingCodesRegistryStore.updateSelectedItems(selectedRowKeys);
};

onMounted(() => markingCodesRegistryStore.loadData());
</script>

<style scoped lang="scss"></style>
